import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './automatic-grid.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

/**
 * Automatic cards in a row
 *
 * @element hf-automatic-grid
 */
export default class AutomaticGrid extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      styleClass: { type: String },
      /**
       * Number of columns
       */
      columns: { type: String },
    };
  }

  constructor() {
    super();
    this.title = '';
    this.styleClass = '';
    this.columns = '';
  }

  render() {
    return html`
      <div
        class="${classMap({
          'automatic-grid': true,
          [`automatic-grid--${this.styleClass}`]: !!this.styleClass,
        })}"
      >
        <div 
          class="${classMap({
            'automatic-grid__list': true,
            [`automatic-${this.columns}-columns-grid__list`]: !!this.columns,
          })}"
        >
          <slot></slot>
        </div>
      </div>
    `;
  }
}
customElements.define('hf-automatic-grid', AutomaticGrid);
